<template>
<div>
  <!--  编辑用户弹框组件-->
  <el-dialog
    title="编辑"
    :visible.sync="dialogVisible"
    :close-on-click-modal=false
    width="50%"
    :append-to-body=true
    :before-close="handleClose">
    <!--  表单-->
    <el-form  ref="ruleForm" :inline="true"  :rules="rules" :model="ruleForm" class="demo-form-inline" label-width="90px" >
      <el-form-item label="姓名:" prop="name" width="20px">
        <el-input v-model="ruleForm.name" placeholder="输入内容" ></el-input>
      </el-form-item>
      <el-form-item label="机构:" prop="organ" width="20px">
        <el-input v-model="ruleForm.organ" placeholder="输入内容"  @click.native="clickOrgan"></el-input>
      </el-form-item>
      <el-form-item label="角色:" prop="roleCode" width="20px">
        <el-select v-model="ruleForm.roleCode" placeholder="请选择" style="width: 200px;">
<!--          <el-option label="全部" value=""></el-option>-->
          <el-option v-for="(item,index) in $store.state.dict.RoleList" :label="item.roleName" :value="item.roleCode"></el-option>
<!--          <el-option label="评审员" value="2"></el-option>-->
<!--          <el-option label="投稿用户" value="3"></el-option>-->
<!--          <el-option label="注册用户" value="4"></el-option>-->
        </el-select>
      </el-form-item>
      <el-form-item label="账号:" prop="loginName" width="20px">
        <el-input v-model="ruleForm.loginName" placeholder="输入内容" ></el-input>
      </el-form-item>
      <el-form-item label="密码:" prop="password" width="20px" >
        <el-input v-model="ruleForm.password" placeholder="输入内容" type="text"></el-input>
      </el-form-item>
      <el-form-item label="联系邮箱:" prop="email" width="20px">
        <el-input v-model="ruleForm.email" placeholder="输入内容" ></el-input>
      </el-form-item>
      <el-form-item label="联系手机号:" width="20px">
        <el-input v-model="ruleForm.phone" placeholder="输入内容" ></el-input>
      </el-form-item>
<!--      <el-form-item>-->
<!--        <el-button type="primary" @click="onSubmit">查询</el-button>-->
<!--        <el-button type="primary" @click="resetForm">重置</el-button>-->
<!--      </el-form-item>-->
    </el-form>

    <span slot="footer" class="dialog-footer">
      <div class="foot-box">
        <!-- <create-user-tip-component></create-user-tip-component> -->
        <div>
          <el-button @click="dialogVisible = false">{{$t("common.cancelSpace")}}}</el-button>
          <el-button type="primary" @click="onSubmit">{{$t('common.trueText')}}</el-button>
        </div>
      </div>
    </span>
    <organ-add-component ref="organ-add-component" @choseOrgan="choseOrgan"></organ-add-component>
  </el-dialog>
</div>
</template>

<script>
import createUserTipComponent from "@/components/user/createUserTipComponent";
import organAddComponent from "./createUser/organAddComponent";
export default {
  data(){
    // [
    //   {roleName:'管理员',roleCode:'1'},
    //   {roleName:'评审员',roleCode:'2'},
    //   {roleName:'投稿用户',roleCode:'3'},
    //   {roleName:'注册用户',roleCode:'4'},
    // ]
    return {
      dialogVisible:false,
      index:'',
      ruleForm:{
        name:'',
        organ:'',
        loginName:'',
        password:'',
        email:'',
        phone:'',
        roleCode:'',
        roleName:'',
      },
      rules:{
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        organ: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
        ],
        loginName: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
        ],
        roleCode: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
          {min: 6, max: 18, pattern: /^[A-Za-z0-9]{6,18}$/,  message: this.$t('common.pleaseInputPass'), trigger: "blur",},
        ],
        email: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
          {pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: "请输入正确的邮箱", trigger: "blur",},
        ],
      },

    }
  },
  components:{
    createUserTipComponent,
    organAddComponent,
  },
  mounted(){

  },
  methods:{
    clickOrgan(){
      this.$refs['organ-add-component'].handleOpen()
    },
    choseOrgan(item){
      this.ruleForm.organ = item.organName
    },
    //初始化弹出列表
    hadleOpen(index,item){
      this.index = index;
      this.dialogVisible = true;
      this.ruleForm = JSON.parse(JSON.stringify(item));
    },
    handleClose(done) {
      done();
      this.resetForm();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    onSubmit(){
      let that = this;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          that.$emit("changeUserInfoItemByIndex",this.ruleForm,this.index)
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      // this.dialogVisible = false
    },
    resetForm(){
      this.ruleForm = {
        name:'',
        roleCode:'',
        roleName:'',
        organ:'',
        loginName:'',
        password:'',
        mail:'',
        phone:'',
      }
    },
  }

}
</script>

<style scoped lang="scss">
.foot-box{
  display: flex;
  justify-content: space-between;
  p{
    text-align: left;
  }
}
</style>
